import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';

class Select extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    static propTypes = {
        disabled: PropTypes.bool,
        options: PropTypes.array,
        customClassNames: PropTypes.string,
        name: PropTypes.string,
        /* Tooltips */
        onChange: PropTypes.func,
        showError: PropTypes.func,
        getErrorMessage: PropTypes.func,
        isFormSubmitted: PropTypes.func,
        isValid: PropTypes.func,
        value: PropTypes.any
    };

    static defaultProps = {
        customClassNames: '',
        defaultOption: {},
        defaultOptionDisabled: true,
        name: '',
        disabled: false,
        options: [],
        toolTipMessage: '',
        showTooltip: false,
        onChange: () => {},
        showError: () => {},
        isFormSubmitted: () => {},
        isValid: () => {},
        isRequired: () => {},
        value: ''
    };

    componentWillReceiveProps(nextProps) {
        const { value } = nextProps;

        if (value) {
            this.setState({ value });
        }
    }

    render() {
        const {
            disabled,
            options,
            customClassNames,
            showError,
            name,
            getErrorMessage,
            isFormSubmitted,
            isValid,
            onChange,
            value
        } = this.props;

        const selectOptionsWithDefault = [].concat(options);

        const getValue = v => {
            if (typeof v === 'boolean') {
                return v;
            }
            return v || '';
        };

        const selectOptions = selectOptionsWithDefault.map((option, i) => (
            <option key={i} value={getValue(option.value)} disabled={option.disabled}>
                {option.label}
            </option>
        ));

        const selectClass = classNames('select', { disabled }, { filled: value });

        // Required as div become uneven when message appended
        const fillerText = 'invisible filler text';

        /* Validation states */
        let rootValidationClassname = '';

        if (showError()) {
            rootValidationClassname += 'error';
        }

        if (isFormSubmitted()) {
            rootValidationClassname = isValid() ? 'success' : 'error';
        }

        return (
            <div className={classNames('form-field-wrapper', customClassNames)}>
                <div className={`select-div form-field form-field--custom ${rootValidationClassname}`}>
                    <i className={classNames('select-icon', {'select-icon--disabled': disabled})} />
                    <select className={selectClass} onChange={onChange} value={value} disabled={disabled} name={name}>
                        {selectOptions}
                    </select>
                    <span className="input-message">{getErrorMessage() || fillerText}</span>
                </div>
            </div>
        );
    }
}

export default withFormsy(Select);
